/** Endereços do cliente HTTP tipado; sem destino implícito de produção. */
function configuredUrl(value: string | undefined, variable: string): string {
  const message = `${variable} deve conter uma URL HTTP(S) absoluta, sem credenciais, query ou fragmento.`
  if (!value?.trim()) throw new Error(message)

  let url: URL
  try {
    url = new URL(value)
  } catch {
    throw new Error(message)
  }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error(message)
  }
  return url.toString().replace(/\/+$/, '')
}

const apiBaseUrl = configuredUrl(import.meta.env.VITE_API_BASE_URL, 'VITE_API_BASE_URL')
const derivedBackendUrl = apiBaseUrl.replace(/\/api$/, '')

export const HTTP_URLS = Object.freeze({
  api: apiBaseUrl,
  backend: configuredUrl(import.meta.env.VITE_BACKEND_BASE_URL || derivedBackendUrl, 'VITE_BACKEND_BASE_URL'),
  sanctum: configuredUrl(import.meta.env.VITE_SANCTUM_BASE_URL || derivedBackendUrl, 'VITE_SANCTUM_BASE_URL'),
})
